import { Fragment } from 'react'

import { FlexGrid, Skeleton, Spacer, Box, Card } from '@telus-uds/components-web'
import { ArticleContainer } from './ArticlePreview/styles'
import { StoryContainer, BlogContainer } from './styles'

export type Props = {
  count: number
  theme: 'blog' | 'story'
}
const SkeletonViewArticles = ({ theme, count }: Props) => {
  const Container = theme === 'story' ? StoryContainer : BlogContainer

  const SkeletonViewBlog = () => {
    return (
      <Card
        fullBleedContent={{
          position: 'bottom',
          content: <Skeleton sizePixels={160} tokens={{ baseWidth: 100, radius: 0 }} />,
        }}
      >
        <Skeleton sizeIndex={3} characters={3} />
        <Spacer space={3} />
        <Skeleton lines={2} characters={8} />
      </Card>
    )
  }
  const SkeletonViewStory = () => {
    return (
      <ArticleContainer data-testid="story-skeleton">
        <Skeleton sizePixels={220} tokens={{ baseWidth: 100, radius: 0 }} />
        <Spacer space={4} />
        <Skeleton lines={2} characters={5} />
        <Spacer space={4} />
        <Skeleton characters={2} />
      </ArticleContainer>
    )
  }
  return (
    <Container role="progressbar" aria-valuetext="Loading..." data-testid="loading">
      {Array(count)
        .fill('')
        .map((_, index) => {
          return (
            <Fragment key={index}>
              {theme === 'blog' ? (
                <Box vertical={3} horizontal={3}>
                  <div data-testid="blog-skeleton">
                    <SkeletonViewBlog />
                  </div>
                </Box>
              ) : (
                <FlexGrid.Col xs={12} sm={6} lg={4}>
                  <SkeletonViewStory />
                </FlexGrid.Col>
              )}
            </Fragment>
          )
        })}
    </Container>
  )
}

export default SkeletonViewArticles
